import { BaSeIcon } from "@base/react";
import "./index.scss";
const BtnResult = ({callback}) => {
  return (
    <div className="wrapper-btn-result" onClick={() => callback()}>
      <span>
        Baseado nos seus resultados, trouxemos algumas sugestões de conteúdo
      </span>
      <figure>
        <BaSeIcon
          color="#ffffff"
          description="seta para a direita"
          size={24}
          name="system/arrow-right-s-line"
        />
      </figure>
    </div>
  );
};

export default BtnResult;
